import { render } from "./TodoCardShowEntrega.vue?vue&type=template&id=24c142aa"
import script from "./TodoCardShowEntrega.vue?vue&type=script&lang=js"
export * from "./TodoCardShowEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__